import { computed, ref } from "vue";

/**
 * The static (non-scrolled) header height
 */
export const headerStaticHeight = ref<number | undefined>();

/**
 * The core (without any teleported/slot content) header scrolled height
 */
export const headerScrolledCoreHeight = ref<number | undefined>();

/**
 * The core (without any teleported/slot content) header scrolled height plus its top offset (including mobile header).
 * This is used for the offset at which items attached to the scrolled header are picked up.
 */
export const headerScrolledCoreTopOffset = ref<number | undefined>();

/**
 * Heights of extra items that may be teleported to the header.
 */
export const headerScrolledPickupItemHeights = ref(new Map<string, number>());

/**
 * The projected extra height added to the scrolled header after teleporting items to it.
 * This is used for the section navigation attached to the header, to estimate in advance the required extra scroll position once the pick-up threshold is passed.
 */
export const headerScrolledProjectedExtraHeight = computed(() =>
  Array.from(headerScrolledPickupItemHeights.value.values()).reduce((sum, number) => sum + number, 0),
);
